import Emitter from "../../helpers/emitter"
import * as emits from "../../constants/emits"

export default class ShopButtonModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.elem.openModal = elem.dataset.openModal && JSON.parse(elem.dataset.openModal)
    self.init()
    return self
  }

  init() {
    const self = this
    self.addEventListeners()
  }

  addEventListeners() {
    const self = this
    self.elem.addEventListener("click", (e) => this.handleButtonClick(e))
  }

  handleButtonClick(e) {
    const self = this

    if (self.elem.openModal) {
      e.preventDefault()
      Emitter.emit("*", {
        type: emits.REQUEST_CONTENT_MODAL_OPEN,
        modalJson: self.elem.openModal,
      })
    }
  }
}
